// extracted by mini-css-extract-plugin
module.exports = {"section":"H_section__2ZvlL","scrollUp":"H_scrollUp__h_6Dq"};